export default {
    "Now": "Agora",
    "now": "agora",
    "recent": "recente",
    "Forgot_password": "Esqueci-me da password",
    "Email_address": "Endereço e-mail",
    "Password": "Palavra-passe",
    "Passwords_dont_match": "As palavras-passe não correspondem",
    "Please_fill_all_fields": "Por favor, preencha todos os campos",
    "Password_changed_successfully": "Palavra-passe alterada com sucesso",
    "Email_sent_recover_password": "Foi enviado um email com instruções para recuperar a palavra-passe",
    "An_error_occurred": "Ocorreu um erro.",
    "Wrong_old_password": "Palavra-passe atual errada",
    "Reset_password": "Recuperar password",
    "Send": "Enviar",
    "INVALID_TOKEN": "Token inválido",
    "WRONG_PASSWORD_CONFIRMATION": "As palavras-passe não coincidem",
    "PRODUCER_NOT_FOUND": "Utilizador não encontrado",
    "Insert_new_password": "Inserir nova password",
    "Vehicle_error": "Erro no veículo",
    "Error_in_equipment": "Erro no equipamento de medição",
    "Instructions": "Instruções",
    "Remove_vehicle_from_station": "Retire o veículo da estação",
    "Contact_vehicle_supplier": "Contacte o fabricante do veículo",
    "Problem_persists_contact": "Se o problema persistir, por favor contacte",
    "Check_if_equipment_off": "Verifique se o equipamento está",
    "disconnected_from_power": "desligado da eletricidade",
    "and_connect_it": "e ligue-o",
    "Otherwise_follow_steps": "Caso contrário, se estiver ligado, siga os seguintes passos",
    "Connect_vehicle_to_station": "Conecte o veículo à estação",
    "Open_box_shutdown_circuit_wait": "Abra a caixa da estação, desligue o disjuntor e aguarde 5 minutos",
    "Turn_circuit_wait": "Volte a ligar o disjuntor e aguarde 5 minutos",
    "Not_enough_power": "Sem potência suficiente",
    "Station_max_power": "Potência máxima da estação",
    "No_information": "Sem informação",
    "Station_error": "Erro na estação",
    "Total_available_power": "Potência total disponível",
    "empty": "vazio",
    "Plug": "Tomada",
    "Next": "Seguinte",
    "Previous": "Anterior",
    "Single_phase": "Monofásico",
    "Three_phase": "Trifásico",
    "Login": "Entrar",
    "Cancel": "Cancelar",
    "Schedule": "Agendar",
    "Confirm_schedule": "Confirmar agendamento",
    "Confirm": "Confirmar",
    "charging": "carregamento",
    "Charging": "A carregar",
    "Car_connected": "Carro conetado",
    "Car_not_connected": "Carro não conetado",
    "Charging_will_start": "O carregamento irá iniciar",
    "Charging_will_finish": "O carregamento irá terminar",
    "in_the_next_few_seconds": "nos próximos segundos",
    'Coffee Machine': "Máquina de café",
    'Microwave': "Microondas",
    "TV": "TV",
    "Kettle": "Chaleira",
    "Freezer": "Congelador",
    "Vacuum Cleaner": "Aspirador",
    "Game Console": "Consola de jogos",
    "Cable Modem": "Modem a cabo",
    "Ham Slicer": "Máquina de cortar fiambre",
    "Entertainment": "Entretenimento",
    "Stove": "Fogão",
    "Oven": "Forno",
    "Fridge": "Frigorífico",
    "Iron": "Ferro de engomar",
    "Washing Machine": "Máquina de lavar roupa",
    "Dishwasher": "Máquina de lavar louça",
    "Toaster": "Tostadeira",
    "Water Pump": "Bomba de água",
    "Kitchen Hood": "Exaustor",
    "Living Room": "Sala de estar",
    "Living Room 1": "Sala de estar 1",
    "Living Room 2": "Sala de estar 2",
    "Juice Maker": "Máquina de sumos",
    "Cooking Machine": "Robô de cozinha",
    "Laptop PC": "Computador portátil",
    "Mixer": "Batedeira",
    "Desktop PC": "Computador",
    "Corridor": "Corredor",
    "Charge": "Carregamento",
    "Automatic": "Automático",
    "Charging_mode": "Modo de carregamento",
    "Charging_in_mode": "A carregar no modo",
    "Charging_will_be_done_automatically": "O carregamento será feito com valores calculados automaticamente.",
    "Select_power_of_charge": "Defina a potência do carregamento",
    "Power_to_apply_vehicle": "Potência a aplicar no veículo",
    "Manual": "Manual",
    "Start": "Início",
    "End": "Fim",
    "Finish": "Terminar",
    "No_Data": "Sem dados para mostrar",
    "Session_expired": "A sessão expirou. Entre novamente.",
    "Accumulated": "Acumulado",
    "last_access": "Último acesso",
    "hello": "Olá",
    "family": "família",
    "production": "produção",
    "consumption": "consumo",
    "production_not_used": "produção não utilizada",
    "Production": "Produção",
    "Consumption": "Consumo",
    "Consumption_by_battery": "Consumo pela bateria",
    "Production_not_used": "Produção não utilizada",
    "Production_used": "Produção utilizada",
    "Production_used_House": "Produção utilizada pela casa",
    "Production_used_Battery": "Produção utilizada pela bateria",
    "View_data_from": "Consulte os seus dados desde",
    "Last_hour": "Última hora",
    "Last_24_hours": "Últimas 24 horas",
    "Last_7_days": "Últimos 7 dias",
    "Last_30_days": "Últimos 30 dias",
    "more_recent": "mais recente",
    "historical": "histórico",
    "comparison": "comparação",
    "appliances": "aparelhos",
    "electric_vehicles": "veículos elétricos",
    "Total_Production": "Produção total",
    "Total_Consumption": "Consumo total",
    "Forecast_production": "Produção (previsão)",
    "Forecast_consumption": "Consumo (previsão)",
    "Next_hours": "Próximas horas",
    "Station": "Estação",
    "substations": "subestações",
    "Substation": "Subestação",
    "transformation_stations": "postos de transformação",
    "Transformation_station": "Posto de transformação",
    "Load_diagram": "Diagrama de carga",
    "Load": "Carga",
    "State_of_charge": "Estado de carga",
    "System_data": "Dados do sistema",
    "Current_electricity": "Corrente",
    "Voltage": "Voltagem",
    "Apparent_power": "Potência aparente",
    "Power_factor": "Fator de potência",
    "control": "controlo",
    "Set": "Definir",
    "Active_power": "Potência ativa",
    "Reactive_power": "Potência reativa",
    "Frequency": "Frequência",
    "Mode": "Modo",
    "Go_to_admin": "Ir para Admin",
    "Change_password": "Mudar palavra-passe",
    "Logout": "Sair",
    "Export": "Exportar",
    "Loading": "Carregando",
    "Battery": "Bateria",
    "new": "novo",
    "Battery_data": "Dados da bateria",
    "Welcome_back": "Bem-vindo de volta",
    "Wrong_credentials": "Credenciais incorretas",
    "Savings": "Poupança",
    "Actual_usage": "Uso actual de energia",
    "of_the_energy_consumed": "da energia consumida",
    "in_last_hour": "na última hora",
    "in_last_24_hours": "nas últimas 24 horas",
    "in_last_7_days": "nos últimos 7 dias",
    "in_last_30_days": "nos últimos 30 dias",
    "was_produced_by_system": "foi produzida pelo seu sistema",
    "hour": "hora",
    "selected_date": "data selecionada",
    "Select_control_mode": "Selecione o modo de controlo",
    "Idle": "Inativo",
    "Voltage_control": "Controlo de voltagem",
    "HBF_Voltage_control": "Controlo de voltagem HBF",
    "From": "Desde",
    "To": "Até",
    "Current": "Atual",
    "Current_mode": "Modo atual",
    "Set_control_mode": "Definir modo de controlo",
    "No_setpoints": "Sem setpoints",
    "Since": "Desde",
    "in_use": "em uso",
    "Battery_occupation": "Ocupação bateria",
    "Energy_consumed_from_grid":"Energia consumida da rede elétrica",
    "Energy_consumed_from_grid_to_house":"Energia consumida da rede elétrica pela casa",
    "Energy_consumed_from_grid_to_battery":"Energia consumida da rede elétrica pela bateria",
    "Energy_consumed_from_production":"Energia consumida da produção",
    "Energy_consumed_by_house_from_production":"Energia consumida da produção pela casa",
    "Energy_consumed_by_battery_from_production":"Energia consumida da produção pela bateria",
    "Energy_consumed_from_battery_to_house": "Energia consumida da bateria pela casa",
    "Energy_produced_consumed_by_battery": "Energia produzida consumida pela bateria",
    "Electric_grid": "Rede elétrica",
    "Electric_grid_to_house": "Rede elétrica para casa",
    "Electric_grid_to_battery": "Rede elétrica para bateria",
    "Production_to_house": "Produção para casa",
    "Production_to_battery": "Produção para bateria",
    "Battery_to_house": "Bateria para casa",
    "Wasted_energy": "Energia desperdiçada",
    "Consumption_details": "Detalhes do consumo",
    "Recent_usage": "Uso recente de energia",
    "Total_energy_consumed": "Energia total consumida",
    "Total_energy_produced": "Energia total produzida",
    "Day_of_week": "Dia da semana",
    "Production_Consumption_Weekdays_Weekends": "Produção e Consumo - Dias de semana/Fins-de-semana",
    "Appliances_breakdown": "Decomposição de aparelhos",
    "Appliance": "Aparelho",
    "appliance": "aparelho",
    "Car": "Carro",
    "Not_charging": "Não está a carregar",
    "Close": "Fechar",
    "Share": "Quota",
    "Partly_cloudy": "Céu pouco nublado",
    "All": "Todos",
    "Cloudy": "Céu nublado",
    "Rainy": "Chuva",
    "Clear": "Céu limpo",
    "Snowy": "Neve",
    "Hail": "Granizo",
    "Wind": "Vento forte",
    "Heavy_rain": "Chuva forte",
    "Showers": "Aguaceiros",
    "Fog": "Nevoeiro",
    "Thunderstorm": "Trovoada",
    "Period_of_time": "Período de tempo",
    "Select_period_of_time": "Selecione o período de tempo",
    "Select_appliance": "Selecione o aparelho",
    "Select_date": "Selecione a data",
    "Start_date": "Data início",
    "End_date": "Data fim",
    "Click_button_below_to_add_setpoints": "Clique no botão abaixo para adicionar mais setpoints.",
    "Date": "Data",
    "Dates": "Datas",
    "View": "Ver",
    "Day": "Dia",
    "Week": "Semana",
    "Month": "Mês",
    "Cheapest_hours": "Horário mais barato",
    "Battery_wont_be_used": "Bateria que não vai ser utilizada",
    "Battery_limits": "Limites da bateria",
    "Energy_usage": "Uso de energia",
    "Production_and_Consumption": "Produção e Consumo",
    "this_day": "neste dia",
    "this_month": "neste mês",
    "this_week": "nesta semana",
    "Current_password": "Palavra-passe atual",
    "New_password":"Nova palavra-passe",
    "Consumption_of_produced_energy": "Consumo da energia produzida",
    "Device": "Dispositivo",
    "at": "às",
    "Not_available": "Não disponível",
    "Normal": "Normal",
    "Smart": "Inteligente",
    "Type_of_charge": "Tipo de carregamento",
    "Battery_charge": "Carga da bateria",
    "Battery_discharge": "Descarga da bateria",
    "of_the_appliances_total_consumption_was_from": "do consumo total de aparelhos foi de",
    "comparison_tooltip_consumption":"Esta secção mostra os dados de consumo para as duas datas selecionadas, em Watts (W).",
    "comparison_tooltip_prod_cons": "Esta secção mostra os dados totais de consumo e produção para as duas datas selecionadas, em kWh.",
    "comparison_tooltip_energy_use": "Esta secção detalha a origem do consumo e o desperdício, para as duas datas selecionadas, em kWh.",
    "comparison_tooltip_cons_produced": "Esta secção indica quanto da energia consumida foi produzida pelo seu sistema, nas duas datas selecionadas.",
    "historical_tooltip_energy_usage": "Esta secção mostra os dados de consumo, produção e produção não utilizada (desperdício) para a data selecionada, em Watts (W).",
    "historical_tooltip_savings": "Esta secção indica os valores de poupança em termos energéticos (kWh), monetários (€) e ambientais (gCO2) para a data selecionada.",
    "historical_tooltip_wastings": "Esta secção indica quanto da energia produzida não foi utilizada (desperdiçada) na data selecionada, em kWh.",
    "historical_tooltip_cons_details": "Esta secção indica a origem da energia consumida e a quantidade, na data selecionada, em kWh.",
    "historical_tooltip_prod_cons_weeks": "Esta secção mostra os dados de consumo, produção e produção não utilizada para cada dia da semana selecionada, em kWh.",
    "historical_tooltip_prod_cons_months": "Esta secção mostra os dados de consumo, produção e produção não utilizada para cada semana e fim-de-semana do mês selecionado, em kWh.",
    "home_tooltip_actual_usage": "Esta secção indica os valores atuais de energia consumida, produzida e desperdiçada, em Watts (W).", 
    "home_tooltip_select_period": "Nesta secção pode selecionar o período de tempo que deseja ver até ao momento.", 
    "home_tooltip_recent_usage": "Esta secção mostra os dados de consumo, produção e desperdício ao longo do período selecionado, em Watts (W).", 
    "home_tooltip_savings": "Esta secção indica os valores de poupança em termos energéticos (kWh), monetários (€) e ambientais (gCO2) para o período selecionado.", 
    "home_tooltip_wastings": "Esta secção indica quanto da energia produzida não foi utilizada (desperdiçada), para o período selecionado, em kWh.",
    "home_tooltip_cons_details": "Esta secção indica a origem da energia consumida e a quantidade, para o período selecionado, em kWh.", 
    "home_tooltip_weekdays": "Esta secção indica os valores totais de energia consumida, produzida e produzida não utilizada para cada dia da semana, em kWh.",
    "home_tooltip_months": "Esta secção indica os valores totais de energia consumida, produzida e produzida não utilizada para dias de semana e fins-de-semana, em kWh.",
    "home_tooltip_battery_occupation": "Esta seção mostra a percentagem de ocupação das baterias juntamente com o período de horas vazias e os limites superior e inferior da bateria, na data selecionada.",
    "appliances_tooltip_breakdown": "Esta secção indica os valores de consumo de cada aparelho e o consumo total, para a data selecionada, em kWh.",
    "appliances_tooltip_appliance": "Esta secção mostra os dados do consumo do aparelho selecionado e a produção não utilizada (desperdício), na data selecionada, em kWh.",
    "ev_tooltip_consumption": "Esta secção mostra os dados do consumo dos veículos elétricos para a data selecionada, em Watts (W)."
}